export default class Approval {
    id: string;
    schoolID: number;
    type: string;
    details: string;
    createdBy: number;
    createdOn: Date;
    approvedBy?: number;
    approvedOn?: Date;
    rejectedBy?: number;
    rejectedOn?: Date;
    rejectionReason?: string;

    constructor(data: Partial<Approval>) {
        Object.assign(this, data);

        this.createdOn = this.createdOn.toDate();
        this.approvedOn = this.approvedOn?.toDate();
        this.rejectedOn = this.rejectedOn?.toDate();
    }
}
